import React from 'react'
import DefaultLink from '../../components/DefaultLink'

const data = [
  {
    img: "/assets/images/about-docs-1.webp",
    title: "Physical Records & Archive Management",
    slug: "/physical-records-management-services",
    btn: "Know More",
  },
  {
    img: "/assets/images/about-docs-2.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    slug: "/ai-document-data-extraction",
    btn: "Know More",
  },
  {
    img: "/assets/images/about-docs-3.webp",
    title: "Scanning & Digitization Services",
    slug: "/document-digitization",
    btn: "Know More",
  },
  {
    img: "/assets/images/about-docs-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    slug: "/data-privacy-governance-compliance-platform",
    btn: "Know More",
  }
]

export default function AboutDocs() {
  return (
    <>
      <section className="about-docs-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div className="about-docs-head">
                <h3 className="heading center-heading">AI-Driven Document Management Solutions</h3>
              </div>
            </div>
          </div>

          <div className="row">
            {data?.map((item, index) => (
              <div key={index} className="col-lg-3 col-md-6">
                <div className="about-docs-box">
                  <img src={item?.img} alt="goal box" />
                  <span>{item?.title}</span>
                  <DefaultLink to={item?.slug} text={item?.btn} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
